import React from 'react'

import S from './Graph.css'

export default function FlowLegend( props ) {

  return (
    <div className={S.flowLegend}>
      <div className={S.blueprint}>
        <div>Blueprint</div>
        <div><i className="fa fa-microchip fa-fw"/>&nbsp; : Hardwire</div>
        <div><i className="fa fa-object-group fa-fw"/>&nbsp; : Organization</div>
      </div>
      <div className={S.oneToOneFlowLink}>
        <div>One to One Relationship</div>
        <div><i className="fa fa-upload fa-fw"/>&nbsp; : Data Forwarding</div>
      </div>
      <div className={S.oneToManyFlowLink}>One to Many Relationship</div>
      <div className={S.manyToOneFlowLink}>Many to One Relationship</div>
      <div className={S.manyToManyFlowLink}>Many to Many Relationship</div>
    </div>
  )
}
